import { z } from "zod";
export const AuthServerSession = z.object({
    id: z.string(),
    refreshToken: z.string(),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date(),
    userId: z.string().optional(),
    identityId: z.string().optional(),
});
